import * as mods from './mod';
import * as main from './main';

if (window.location.pathname.indexOf('/mods') === 0) {
    mods.initPage();
} else {
    main.initPage();
}
